import React from 'react'
import './Message.scss'

const Message = ({user, chat, index, message}) => {

    const determineMargin = () => {
        if (index + 1 === chat.Messages.length) return
        return message.fromUserId === chat.Messages[index + 1].fromUserId ? 'mb-5' : 'mb-10'
    };
    const createdAt = message.createdAt;
    const timeOnly = new Date(createdAt).toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
    });
    const formattedDateTime = new Date(createdAt).toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
    });
    return (
        <div className={`message ${determineMargin()} ${message.fromUserId === user.id ? 'creator' : ''}`}>
            <div className={message.fromUserId === user.id ? 'owner' : 'other-person'}>
                {

                    message.fromUserId !== user.id && message.User

                        ? <h6 className='m-0'>{message.User.firstName} {message.User.lastName}</h6>

                        : null
 
                }
                {
                    message.type === 'text' || message.type === 'bot'
                        ? (
                            <div className="message-bubble">
                                <p className='m-0'>{message.message}</p>
                                <span className="message-time">{timeOnly}</span>
                            </div>
                        )
                        : <img src={message.message} alt='User upload'/>
                }
            </div>
        </div>
    )
};

export default Message